import regardEdit from './edit.vue'
import regardList from './list.vue'

let a = Object.assign({ regardEdit, regardList })
export default a;